import { COLOR } from '#@/shared/utils/styles';

const colors = [
  COLOR.accent1,
  COLOR.accent2,
  COLOR.accent3,
  COLOR.accent4,
  COLOR.accent5,
  COLOR.accent6,
  COLOR.accent7,
  COLOR.accent8,
  COLOR.accent9,
  COLOR.accent10,
];

export const getColorFromName = (name: string | null): COLOR =>
  colors[(name || '').toLocaleLowerCase().charCodeAt(0) % colors.length];
